import styled from 'styled-components';

export const InputContainer = styled.div<{ hasError?: boolean; isPunchup?: boolean }>`
	margin-top: ${({ hasError }) => hasError && '4px'};
	width: 100%;
`;

export const StyledQuillWrapper = styled.div<{ isPunchup?: boolean }>`
	.ql-toolbar {
		border: 1px solid ${({ theme, isPunchup }) => (isPunchup ? '#e5e5e5' : theme.colors.lightGrey4)};
		border-bottom: none;
		background: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : theme.colors.blackGrey3)};
	}

	.ql-toolbar .ql-stroke {
		stroke: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	}

	.ql-toolbar .ql-fill {
		fill: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	}

	.ql-toolbar button {
		color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	}

	.ql-toolbar button:hover {
		background: ${({ theme, isPunchup }) => (isPunchup ? '#f0f0f0' : theme.colors.lightGrey4)};
	}

	.ql-toolbar button.ql-active {
		background: ${({ isPunchup }) => (isPunchup ? '#fe5e25' : '#3b3b3b')};
		color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : theme.colors.white)};
	}

	.ql-toolbar .ql-picker-label {
		color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	}

	.ql-toolbar .ql-picker-options {
		background: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : theme.colors.blackGrey3)};
		border: 1px solid ${({ theme, isPunchup }) => (isPunchup ? '#e5e5e5' : theme.colors.lightGrey4)};
	}

	.ql-toolbar .ql-picker-item {
		color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	}

	.ql-toolbar .ql-picker-item:hover {
		background: ${({ theme, isPunchup }) => (isPunchup ? '#f0f0f0' : theme.colors.lightGrey4)};
	}

	.ql-container {
		border: 1px solid ${({ theme, isPunchup }) => (isPunchup ? '#e5e5e5' : theme.colors.lightGrey4)};
		background: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : theme.colors.blackGrey3)};
		color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
	}

	.ql-editor {
		color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};
		min-height: 150px;
	}

	.ql-editor.ql-blank::before {
		color: ${({ theme, isPunchup }) => (isPunchup ? '#999' : theme.colors.lightGrey2)};
	}

	.ql-container.ql-snow {
		border: 1px solid ${({ theme, isPunchup }) => (isPunchup ? '#e5e5e5' : theme.colors.lightGrey4)};
	}
`;
